export const WORDLE_CORRECT_COLOR = 'rgb(34, 197, 94)';
export const WORDLE_WRONG_COLOR = 'rgb(148, 163, 184)';
export const WORDLE_MISPLACED_COLOR = 'rgb(234, 179, 8)';
export const WORDLE_LOSE_COLOR = 'red';
